import React from 'react';
import { usePermissions } from '../hooks/usePermissions';

const PermissionGuard = ({ module, action = 'lire', children, fallback = null, showMessage = true }) => {
  const { peut, loading } = usePermissions();

  if (loading) return (
    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '200px', color: '#999' }}>
      Vérification des accès...
    </div>
  );

  if (!peut(module, action)) {
    if (!showMessage && fallback) return fallback;
    if (!showMessage) return null;
    return (
      <div style={{
        background: '#fff3e0', border: '2px solid #ff9800', borderRadius: '12px',
        padding: '40px', textAlign: 'center', margin: '24px'
      }}>
        <div style={{ fontSize: '48px', marginBottom: '16px' }}>🔒</div>
        <div style={{ fontWeight: '700', fontSize: '20px', color: '#e65100', marginBottom: '8px' }}>
          Accès non autorisé
        </div>
        <div style={{ color: '#666', fontSize: '14px' }}>
          Votre rôle ne dispose pas de la permission "{action}" sur ce module.
        </div>
        <div style={{ color: '#999', fontSize: '12px', marginTop: '8px' }}>
          Contactez votre administrateur pour modifier vos droits d'accès.
        </div>
      </div>
    );
  }

  return children;
};

export default PermissionGuard;
